import React from 'react';
import { BunkeringStatusEnum } from 'src/types/ViewModel/Bunkering/BunkeringEvent';
import { DebunkeringItemWrapper } from '../Bunkering.styles';
import { prettifyDateTimeHHmm } from 'odfjell-date-time-utils/dateTimeFormatter';
import { BunkerRegistrationStatusIcon } from './status/BunkerRegistrationStatusIcon';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';

interface DeletedBunkeringListItemProps {
    bunkering: Bunkering;
    selected: boolean;
    onSelectDeletedBunkering: (id: string) => void;
}

const DeletedBunkeringListItem: React.FC<DeletedBunkeringListItemProps> = ({ bunkering, selected, onSelectDeletedBunkering }) => {
    return (
        <DebunkeringItemWrapper key={bunkering.bunkeringGuid} selected={selected} onClick={() => onSelectDeletedBunkering(bunkering.bunkeringGuid)}>
            <td>
                <strong>DELETED:</strong> {bunkering.bunkeringReference}
            </td>
            <td>{BunkerRegistrationStatusIcon(bunkering.currentStatus?.status ?? BunkeringStatusEnum.Unknown, bunkering.bunkeringStatuses ?? [])}</td>
            <td>{prettifyDateTimeHHmm(bunkering.bunkeringDateTime)}</td>
            <td></td>
        </DebunkeringItemWrapper>
    );
};

export default DeletedBunkeringListItem;
